

export const designsApi = {
  /**
   * Create a new design
   * @param {Object} data - Design data { name, canvas_data, product_ids, rules }
   * @returns {Promise<Object>} Created design object
   */
  create: async (data) => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_2}/api/designs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
        throw new Error(`Failed to create design: ${res.statusText}`);
    }
    return res.json();
  },
  
  /**
   * List designs
   * @param {number} limit - Number of items (default 50)
   * @param {number} offset - Pagination offset (default 0)
   * @returns {Promise<Array>} Array of design objects
   */
  list: async (limit = 50, offset = 0) => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_2}/api/designs?limit=${limit}&offset=${offset}`);
    if (!res.ok) {
        throw new Error(`Failed to list designs: ${res.statusText}`);
    }
    return res.json();
  },
  
  /**
   * Get a single design
   * @param {string} id - Design ID
   * @returns {Promise<Object>} Design object
   */
  get: async (id) => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_2}/api/designs/${id}`);
    if (!res.ok) {
        throw new Error(`Failed to get design: ${res.statusText}`);
    }
    return res.json();
  },
  
  /**
   * Update a design
   * @param {string} id - Design ID
   * @param {Object} data - Partial updates { name, product_ids, ... }
   * @returns {Promise<Object>} Updated design object
   */
  update: async (id, data) => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_2}/api/designs/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
        throw new Error(`Failed to update design: ${res.statusText}`);
    }
    return res.json();
  },
  
  /**
   * Delete a design
   * @param {string} id - Design ID
   * @returns {Promise<Object>} { success: true, message: "Design deleted" }
   */
  delete: async (id) => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_2}/api/designs/${id}`, { method: 'DELETE' });
    if (!res.ok) {
        throw new Error(`Failed to delete design: ${res.statusText}`);
    }
    return res.json();
  }
};
